import { Injectable } from '@angular/core';
import { ApiHttp } from 'app/providers';
import { BaseResponse, GphAssignmentsResponse, GphProgramsResponse } from '../models/gph-ops.model';

@Injectable({ providedIn: 'root' })
export class GphOpsService {
    constructor(private api: ApiHttp) {}

    getPrograms(): Promise<GphProgramsResponse> {
        return this.api.post('api/GphOps/GetPrograms', {});
    }

    getAssignments(): Promise<GphAssignmentsResponse> {
        return this.api.post('api/GphOps/GetAssignments', {});
    }

    assignRider(payload: any): Promise<BaseResponse> {
        return this.api.post('api/GphOps/AssignRider', payload);
    }

    unassignRider(payload: any): Promise<BaseResponse> {
        return this.api.post('api/GphOps/UnassignRider', payload);
    }
}
